import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from './ui/button';

/**
 * Global back button that appears on most pages (except /home and landing).
 * Uses history.back() semantics with a safe fallback to /home.
 */
const GlobalBackButton = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Pages where the back button should NOT appear
  const hiddenPaths = ['/', '/landing', '/home'];

  // Also hide on Page Builder Studio routes
  const isPageBuilderStudio = location.pathname.includes('/admin/page-builder/') && 
                              !location.pathname.endsWith('/page-builder');

  if (hiddenPaths.includes(location.pathname) || isPageBuilderStudio) {
    return null;
  }

  const handleBack = () => {
    // If there's a meaningful history entry, go back; otherwise, go to /home
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/home', { replace: true });
    }
  };

  return (
    <div className="fixed top-16 left-4 z-40">
      <Button
        variant="outline"
        size="sm"
        onClick={handleBack}
        className="border-gray-700 bg-black/60 text-gray-100 hover:bg-black/80 hover:text-white flex items-center gap-2 px-3 py-1 rounded-full shadow-lg backdrop-blur-sm"
      >
        <ArrowLeft className="w-4 h-4" />
        <span className="text-sm font-medium">Back</span>
      </Button>
    </div>
  );
};

export default GlobalBackButton;
